import { Component, Input, OnInit } from '@angular/core';
import { PRODUCTS } from '../../../../../../shared/product/products';
import { CalendarComponent } from '../../components/booking/calendar.component';
import { EventComponent } from '../../components/event/event.component';
import { InvoiceComponent } from '../../components/invoice/invoice.component';
import { PhysicalProductComponent } from '../../components/physical-product/physical-product.component';
import { QuickPaymentComponent } from '../../components/quick-payment/quick-payment.component';
import { SubscriptionComponent } from '../../components/subscription/subscription.component';
import { GetCalculatesParamsService } from '../../../../services/get-calculates-params.service';
import { ReservationComponent } from '../../components/reservation/reservation.component';
import { ClaimComponent } from '../../components/claim/claim.component';

@Component({
  selector: 'app-buyer-view',
  templateUrl: './buyer-view.component.html',
  styleUrls: ['./buyer-view.component.scss']
})
export class BuyerViewComponent implements OnInit {
  productCode: any;
  @Input() incomingProduct: any;
  @Input() businessData: any;
  productObject: any = {
    expired: false
  };
  paymentOptions: any = {};
  proceedToPayment: boolean = false;
  // Are we resolving a Physical Product component?
  isPhysicalProduct: boolean = false;

  constructor(
    public getCalculatesParamsService: GetCalculatesParamsService
  ) {}

  async ngOnInit() {
    const whatsappBtn =  document.getElementById('whatsapp-chat-widget');
    if(whatsappBtn) whatsappBtn.style.display = 'block';
    const result = this.incomingProduct;
    this.productObject = result;
    this.fetchViewType(result);
  }

  private fetchViewType(object: any) {
    let templateClass: any;
    if (object.ProductTypeId) {
      let type = '';
      switch (object.ProductTypeId) {
        case PRODUCTS.TYPES.PHYSICAL.ID:
          templateClass = PhysicalProductComponent;
          type = PRODUCTS.TYPES.PHYSICAL.PRODUCT_NAME;
          this.isPhysicalProduct = true;
          break;
        case PRODUCTS.TYPES.EVENT.ID:
          templateClass = EventComponent;
          type = PRODUCTS.TYPES.EVENT.PRODUCT_NAME;
          break;
        case PRODUCTS.TYPES.Calendar.ID:
          templateClass = CalendarComponent;
          type = PRODUCTS.TYPES.Calendar.PRODUCT_NAME;
          break;
        case PRODUCTS.TYPES.INVOICE.ID:
          templateClass = InvoiceComponent;
          type = PRODUCTS.TYPES.INVOICE.PRODUCT_NAME;
          break;
          case PRODUCTS.TYPES.COLLECTION.ID:
          templateClass = ClaimComponent;
          type = PRODUCTS.TYPES.COLLECTION.PRODUCT_NAME;
          break;
        case PRODUCTS.TYPES.QUICK_PAYMENT.ID:
          templateClass = QuickPaymentComponent;
          type = PRODUCTS.TYPES.QUICK_PAYMENT.PRODUCT_NAME;
          break;
        case PRODUCTS.TYPES.Subscription.ID:
          templateClass = SubscriptionComponent;
          type = PRODUCTS.TYPES.Subscription.PRODUCT_NAME;
          break;
          case PRODUCTS.TYPES.Reservation.ID:
          templateClass = ReservationComponent;
          type = PRODUCTS.TYPES.Reservation.PRODUCT_NAME;
          break;
        default:
          return;
      }
      if (type) {
        this.getCalculatesParamsService.setProductType(type);
      }
    }
    // @ts-ignore
    //console.log("object", object);
    this.productObject = object;
  }

}
